"use client";

import { useQuery } from "@tanstack/react-query";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import { useParams } from "react-router";
import { getMemberById } from "../../../services/memberServices";
import MemberDetailed from "../../../components/admin/members/MemberDetailed";
import { ArrowLeft } from "lucide-react";

const MemberDetail = () => {
  const memberId = useParams().id;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["memberProfile", memberId],
    queryFn: () => getMemberById(memberId || undefined),
    enabled: !!memberId,
  });

  const member = data?.data?.member || null;
  const leadershipRole = data?.data?.leadershipRoles || null;

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <Sidebar />
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <div className="w-full flex items-center gap-3">
                <button
                  onClick={() => {
                    window.history.back();
                  }}
                  className="bg-white w-10 h-10 flex justify-center items-center rounded-full mb-4"
                >
                  <ArrowLeft />
                </button>
                <Header
                  title={`Member: ${[
                    member?.profileInfo.title,
                    member?.profileInfo.firstName,
                    member?.profileInfo.middleName,
                    member?.profileInfo.lastName,
                  ]
                    .filter(Boolean)
                    .join(" ")}`}
                  desc="Here you can view member details."
                />
              </div>

              <MemberDetailed member={member} leadershipRole={leadershipRole} />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default MemberDetail;
